"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var dom_1 = require("../utils/dom");
var misc_1 = require("../utils/misc");
var allMove_1 = require("./allMove");
var misc_2 = require("./misc");
/**
 * Create an Obvservable that enables dragging an Element
 * and emits a stream of updated positions.
 */
exports.createDndObservable = function (_a) {
    var element = _a.element, group = _a.group, handle = _a.handle, snapTo = _a.snapTo, snapXTo = _a.snapXTo, snapYTo = _a.snapYTo;
    var mouseDown$ = rxjs_1.fromEvent(handle, 'mousedown');
    return mouseDown$.pipe(operators_1.filter(function (e) { return e.which === 1; }), // left clicks only
    operators_1.tap(allMove_1.allMoveStart$), operators_1.switchMap(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var originalOffset = dom_1.offsetOfElement(element);
        // Account for CSS transform scale
        var scale = dom_1.scaleOfElement(element);
        // consolidate snap values from snapTo, snapXTo, snapYTo
        var snapValues = misc_1.getSnapValues(snapTo, snapXTo, snapYTo);
        var move$ = misc_2.documentMouseMove$.pipe(operators_1.map(changeFromPointToMouseEvent(e.clientX, e.clientY, scale)), operators_1.skipWhile(hasntMovedFivePixels), operators_1.map(adjustForSnap(originalOffset, snapValues)), operators_1.tap(notifyListeners(group)));
        return misc_2.requestAnimationFramesUntil(move$, misc_2.documentMouseUp$, function () {
            return allMove_1.allMoveEnd$.next();
        });
    }));
};
/**
 * Calculates the distance from an origin point to a mouse event
 */
var changeFromPointToMouseEvent = function (originX, originY, scale) { return function (e) {
    var leftChange = (e.clientX - originX) / scale;
    var topChange = (e.clientY - originY) / scale;
    if (!e.shiftKey) {
        return {
            left: leftChange,
            top: topChange,
        };
    }
    var changeRatio = leftChange / topChange;
    var absChangeRatio = Math.abs(changeRatio);
    // Lock to diagonals
    if (0.333 < absChangeRatio && absChangeRatio < 3) {
        return {
            left: leftChange,
            top: topChange / leftChange > 0 ? leftChange : leftChange * -1,
        };
    }
    // Lock to horizontal
    if (Math.abs(leftChange) > Math.abs(topChange)) {
        return {
            left: leftChange,
            top: 0,
        };
    }
    // Lock to vertical
    return {
        left: 0,
        top: topChange,
    };
}; };
/**
 * Determine if the mouse has moved 5 pixels or more in any direction.
 * Change = √(a² + b²)
 */
var hasntMovedFivePixels = function (change) {
    return Math.sqrt(change.top * change.top + change.left * change.left) < 5;
};
/**
 * Adjusts the offset changes so that the element that is being moved
 * ends up in a position that is snapped to the given number.
 *
 * NOTE: If you have grouped elements (via the `group` param),
 * only the element that is being interacted with via mouse
 * will snap, with all other elements simply following along.
 */
var adjustForSnap = function (original, snapValues) { return function (change) {
    if (misc_1.areBothSnapsUndefined(snapValues)) {
        return change;
    }
    var unsnappedOffset = {
        left: original.left + change.left,
        top: original.top + change.top,
    };
    var snapped = misc_1.snapPositionValues(snapValues)(unsnappedOffset);
    var adjustedChange = {
        left: snapped.left - original.left,
        top: snapped.top - original.top,
    };
    return adjustedChange;
}; };
/**
 * Notify allMove observers that a change in mouse position
 * has occurred relative to the initial mouse-down offset.
 */
var notifyListeners = function (group) { return function (offset) {
    return allMove_1.allMoveUpdate$.next({ group: group, offset: offset });
}; };
//# sourceMappingURL=dnd.js.map